"use client";

type ButtonVariant = "primary" | "secondary" | "danger" | "ghost";
type ButtonSize = "sm" | "md";

type Props = {
    variant?: ButtonVariant;
    size?: ButtonSize;
    bordered?: boolean;
    disabled?: boolean;
    type?: "button" | "submit" | "reset";
    onClick?: () => void;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    children: React.ReactNode;
};

const VARIANT: Record<ButtonVariant, string> = {
    primary:
        "bg-interactive-active text-white hover:bg-interactive disabled:opacity-50",
    secondary:
        "bg-surface text-text-primary hover:bg-sidebar-bg disabled:text-text-muted disabled:opacity-50",
    danger:
        "bg-danger text-white hover:bg-danger-active disabled:opacity-50",
    ghost:
        "bg-page-bg text-text-primary hover:bg-sidebar-bg disabled:text-text-muted disabled:opacity-50",
};

/** bordered のデフォルト値（明示指定がない場合に使用） */
const DEFAULT_BORDERED: Record<ButtonVariant, boolean> = {
    primary: false,
    secondary: true,
    danger: false,
    ghost: false,
};

const SIZE: Record<ButtonSize, string> = {
    sm: "px-3 py-1 text-xs gap-1",
    md: "px-4 py-2 text-sm gap-1.5",
};

export function Button({
    variant = "primary",
    size = "md",
    bordered,
    disabled = false,
    type = "button",
    onClick,
    leftIcon,
    rightIcon,
    children,
}: Props) {
    const isBordered = bordered ?? DEFAULT_BORDERED[variant];

    return (
        <button
            type={type}
            disabled={disabled}
            onClick={onClick}
            className={`inline-flex items-center whitespace-nowrap rounded font-medium transition-colors cursor-pointer disabled:cursor-not-allowed [&>svg]:shrink-0 ${VARIANT[variant]} ${SIZE[size]} ${isBordered ? "border border-border-subtle" : ""}`}
        >
            {leftIcon}
            {children}
            {rightIcon}
        </button>
    );
}
